import React, {Component} from "react";
import {createRoot} from "react-dom/client";
import "../../sass/_document.scss";
import Footer from "../components/Footer/Footer";
import Channels from "../components/Channels/Channels";
import Player from "../components/Player/Player";
import Grid from "../components/Grid/Grid";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import Title from "../components/Title/Title";
import Common from "../utils/common";
import AmbassadorHelper from "../utils/AmbassadorHelper";
import store from "../store/store";
import * as actionType from "../store/actions";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import theme from "../../sass/variables.json";

const {asset} = ConfigurationHelper.getGlobalConfiguration().channelVideosData;

class Video extends Component {
    state = {
        breadcrumbsList: [],
        shouldRenderBelow: true,
    };

    api = `${ConfigurationHelper.getGlobalConfiguration().apiUrl}channels/${ConfigurationHelper.getRelatedVideosChannelId()}/contents`;

    checkUrlParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const channelId = parseInt(urlParams.get('channelId'), 10) || 0;

        if (channelId > 0) {
            this.setState({ shouldRenderBelow: false });
        }
    };

    componentDidMount() {
        this.checkUrlParams();
        store.subscribe(this.updateAmbassador)
    }

    updateAmbassador = () => {
        const storeState = store.getState();
        if (storeState.event === actionType.UPDATE_BREADCRUMBS) {
            const breadCrumbs = [];
            if (storeState && storeState.ambassador && ConfigurationHelper.isAmbassadorProgramEnabled()) {
                breadCrumbs.push({
                    name: AmbassadorHelper.getDisplayNameFromApi(storeState.ambassador),
                    url: TVSite.sub_folder + "/a/" + storeState.ambassador.user_slug + "/" + storeState.ambassador.user_id,
                    highlightMobile: true
                });
            } else if (!ConfigurationHelper.isAmbassadorProgramEnabled()) {
                const entityType = storeState.asset.entityType === 7 ? "Photo" : "Video";
                breadCrumbs.push({
                    name: entityType,
                    highlightMobile: false,
                    hideItemOnMobile: true,
                    keepOnMobile: false
                });
            }
            if (storeState && storeState.asset) {
                breadCrumbs.push({
                    name: storeState.asset.title,
                    url: Common.getVideoPageUrl(storeState.asset),
                    active: true,
                    hideItemOnMobile: ConfigurationHelper.isAmbassadorProgramEnabled()
                });
            }
            this.setState({
                breadcrumbsList: breadCrumbs
            });
        }
    }
    getApiUrl = (user_id) => {
        if (user_id)
            return this.api + `?user_id=${user_id}`;
        else
            return this.api;
    }

    render() {
        const channelApiUrl = this.getApiUrl(asset.user_id);
        const {breadcrumbsList, shouldRenderBelow} = this.state;
        return (
            <div className={"document-body "+theme.hub_wrapper_css_class}>
                <Channels onFlagChange={(flagValue) => this.setState({ shouldRenderBelow: flagValue })} />
                {shouldRenderBelow && (
                    <>
                        <Breadcrumbs keepOnMobile breadcrumbsList={breadcrumbsList} />
                        {(asset && asset.id) && <Player enableDetails={true} asset={asset} />}
                        <div className={"container"}>
                            <div className={"row"}>
                                <Title className={"col-12"}>RELATED CONTENT</Title>
                            </div>
                        </div>
                        <Grid gridTitle={null} currentAsset={asset.id} baseApiUrl={channelApiUrl} />
                        {ConfigurationHelper.enableHeaderFooter() && <Footer />}
                    </>
                )}
            </div>
        );
    }
}

const root = createRoot(document.getElementById("app-container"))
root.render(<Video/>);